import type { GetTweetById200ReferencedTweetTweetEngagementAllOf } from './getTweetById200ReferencedTweetTweetEngagementAllOf';
import type { GetTweetById200ReferencedTweetTweetEngagementAllOfTwo } from './getTweetById200ReferencedTweetTweetEngagementAllOfTwo';

export type GetTweetById200ReferencedTweetTweetEngagement = GetTweetById200ReferencedTweetTweetEngagementAllOf & GetTweetById200ReferencedTweetTweetEngagementAllOfTwo;
